import { isMobile, round } from "./utils";
import Split from 'split.js'

export class SettingsManager {

    #settingsKey = "trimDesignerSettings";
    ScaleFactor = 96;

    #profileOnly = false;
    #Snap: boolean = true;
    #SnapPrecision: number = 5;
    #showPoints = true;
    #CircleSize = 10;
    #showPaintIndicator = true;
    #showAngleLabels = true;
    #angleLabelLimit = 180;
    #showLengthLabels = true;
    #lengthLabelLimit = 0;
    #BendRadius = 4.5; // 3/64" Bend radius
    #grayBackground = '#808080';
    #leftWidth = "";
    #rightWidth = "";
    #separatorLeft = "";
    #leftElement: HTMLElement;
    #rightElement: HTMLElement
    #separatorElement: HTMLElement

    #svgContainer = document.querySelector('.svg-container') as HTMLElement;

    #showProfileOnlyInput: HTMLInputElement;
    #snapInput: HTMLInputElement;
    #snapPrecisionInput: HTMLInputElement;
    #showPointInput: HTMLInputElement;
    #pointSizeInput: HTMLInputElement;
    #showPaintIndicatorInput: HTMLInputElement;
    #showAngleLabelsInput: HTMLInputElement;
    #angleLabelLimitInput: HTMLInputElement;
    #showLengthLabelsInput: HTMLInputElement;
    #lengthLabelLimitInput: HTMLInputElement;
    #bendRadiusInput: HTMLInputElement;
    #grayBackgroundInput: HTMLInputElement;
    #splitter: any;


    updateDrawingObjects: CallableFunction;
    #DraggingSeparator: CallableFunction;
    constructor(settingsUpdatedCallback: CallableFunction, afterDraggingSeparator: CallableFunction) {
        let me = this;
        this.updateDrawingObjects = settingsUpdatedCallback;
        this.#DraggingSeparator = afterDraggingSeparator;

        // this.#separatorElement = document.getElementById("separator") as HTMLElement;
        // this.#leftElement = document.getElementById("dataGrid") as HTMLElement;
        // this.#rightElement = document.getElementById("drawing") as HTMLElement;

        let sizes: any = localStorage.getItem('nctd-split-sizes' + me.getOrientation());
        if (sizes) {
            sizes = JSON.parse(sizes)
        } else {
            sizes = [20, 80] // default sizes
        }

        me.#splitter = Split(['#dataGrid', '#drawing'], {
            sizes: sizes,
            minSize: 180,
            onDrag: function () {
                me.#DraggingSeparator();
            },
            onDragEnd: function (sizes) {
                me.#DraggingSeparator();
                localStorage.setItem('nctd-split-sizes' + me.getOrientation(), JSON.stringify(sizes));
            }
        });

        window.onresize = function () {
            if (me.#splitter) {
                let sizes: any = localStorage.getItem('nctd-split-sizes' + me.getOrientation());
                if (sizes) {
                    sizes = JSON.parse(sizes)
                } else {
                    sizes = [20, 80] // default sizes
                }
                me.#splitter.setSizes(sizes);
            }
            me.#DraggingSeparator();
        }

        this.getSettings();
        this.init();
    }


    public get ProfileOnly(): boolean {
        return this.#profileOnly;
    }
    public set ProfileOnly(v: boolean) {
        this.#profileOnly = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get Snap(): boolean {
        return this.#Snap;
    }
    public set Snap(v: boolean) {
        this.#Snap = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get SnapPrecision(): number {
        return this.#SnapPrecision;
    }
    public set SnapPrecision(v: number) {
        this.#SnapPrecision = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get ShowPoints(): boolean {
        return this.#showPoints;
    }
    public set ShowPoints(v: boolean) {
        this.#showPoints = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get PointSize(): number {
        return this.#CircleSize;
    }
    public set PointSize(v: number) {
        this.#CircleSize = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get ShowPaintIndicator(): boolean {
        return this.#showPaintIndicator;
    }
    public set ShowPaintIndicator(v: boolean) {
        this.#showPaintIndicator = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get ShowAngleLabels(): boolean {
        return this.#showAngleLabels;
    }
    public set ShowAngleLabels(v: boolean) {
        this.#showAngleLabels = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get AngleLabelLimit(): number {
        return this.#angleLabelLimit;
    }
    public set AngleLabelLimit(v: number) {
        this.#angleLabelLimit = v;
    }

    public get ShowLengthLabels(): boolean {
        return this.#showLengthLabels;
    }
    public set ShowLengthLabels(v: boolean) {
        this.#showLengthLabels = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get LengthLabelLimit(): number {
        return this.#lengthLabelLimit;
    }
    public set LengthLabelLimit(v: number) {
        this.#lengthLabelLimit = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get BendRadius(): number {
        return this.#BendRadius;
    }
    public set BendRadius(v: number) {
        this.#BendRadius = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    public get BackgroundColor(): string {
        return this.#grayBackground;
    }
    public set BackgroundColor(v: string) {
        this.#grayBackground = v;
        this.writeValuesToInputs();
        this.saveSettings();
    }

    init() {
        let me = this;
        me.#showProfileOnlyInput = document.getElementById("nctdProfileOnly") as HTMLInputElement;
        me.#showProfileOnlyInput?.addEventListener("change", function () {
            me.#profileOnly = this.checked;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#snapInput = document.getElementById("nctdSnap") as HTMLInputElement;
        me.#snapInput.addEventListener("change", function () {
            me.#Snap = this.checked;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#snapPrecisionInput = document.getElementById("nctdSnapPrecision") as HTMLInputElement;
        me.#snapPrecisionInput?.addEventListener("change", function () {
            me.#SnapPrecision = +this.value;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#showPointInput = document.getElementById("nctdShowPoint") as HTMLInputElement;
        me.#showPointInput.addEventListener("change", function () {
            me.#showPoints = this.checked;
            me.saveSettings();
            me.updateDrawingObjects();
        });

        me.#pointSizeInput = document.getElementById("nctdPointSize") as HTMLInputElement;
        me.#pointSizeInput.addEventListener("change", function () {
            me.#CircleSize = +this.value;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#showPaintIndicatorInput = document.getElementById("nctdShowPaintIndicator") as HTMLInputElement;
        me.#showPaintIndicatorInput.addEventListener("change", function () {
            me.#showPaintIndicator = this.checked;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#showAngleLabelsInput = document.getElementById("nctdShowAngleLabelsUnder") as HTMLInputElement;
        me.#showAngleLabelsInput.addEventListener("change", function () {
            me.#showAngleLabels = this.checked;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#angleLabelLimitInput = document.getElementById("nctdAngleLabelLimit") as HTMLInputElement;
        me.#angleLabelLimitInput.addEventListener("change", function () {
            me.#angleLabelLimit = +this.value;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#showLengthLabelsInput = document.getElementById("nctdShowLengthLabels") as HTMLInputElement;
        me.#showLengthLabelsInput.addEventListener("change", function () {
            me.#showLengthLabels = this.checked;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#lengthLabelLimitInput = document.getElementById("nctdLengthLabelLimit") as HTMLInputElement;
        me.#lengthLabelLimitInput.addEventListener("change", function () {
            me.#lengthLabelLimit = +this.value;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#bendRadiusInput = document.getElementById("nctdBendRadius") as HTMLInputElement;
        me.#bendRadiusInput.addEventListener("change", function () {
            me.#BendRadius = +this.value * me.ScaleFactor;
            me.updateDrawingObjects();
            me.saveSettings();
        });

        me.#grayBackgroundInput = document.getElementById("nctdGrayBackground") as HTMLInputElement;
        me.#grayBackgroundInput.addEventListener("change", function () {
            me.#grayBackground = this.value;
            me.#svgContainer.style.backgroundColor = me.#grayBackground;
            me.saveSettings();
        });

        let resetSettingsButton = document.getElementById('nctdResetSettings') as HTMLButtonElement;
        resetSettingsButton.addEventListener("click", function () {
            localStorage.removeItem(me.#settingsKey);
            me.resetSettings();
        });

        let showHideSettingsButton = document.getElementById("showHideSettings");
        showHideSettingsButton?.addEventListener("click", function () {
            let x = document.getElementById("trimDesignerSettings");
            let show = x!.style.display === 'none';
            x!.style.display = x!.style.display === 'none' ? 'block' : 'none';
            this.innerText = x!.style.display === 'none' ? 'Show Settings' : 'Hide Settings';
        });

        this.writeValuesToInputs();
    }



    resetSettings() {
        this.#Snap = true;
        this.#SnapPrecision = 5;
        this.#profileOnly = false;
        this.#showPoints = true;

        if (isMobile()) {
            this.#CircleSize = 30;
        } else {
            this.#CircleSize = 10;
        }

        this.#showPaintIndicator = true;
        this.#showAngleLabels = true;
        this.#angleLabelLimit = 180;
        this.#showLengthLabels = true;
        this.#lengthLabelLimit = 0;
        this.#grayBackground = '#808080';
        this.#BendRadius = 4.5;
        this.saveSettings();
        this.writeValuesToInputs();
        this.updateUI();

        // this.#separatorElement.style.left = '';
        // this.#leftElement!.style.width = '';
        // this.#rightElement!.style.width = '';

    }

    writeValuesToInputs() {
        let me = this;
        me.#showProfileOnlyInput.checked = this.#profileOnly;
        me.#snapInput.checked = this.#Snap;
        me.#snapPrecisionInput.value = this.#SnapPrecision.toString();
        me.#showPointInput.checked = this.#showPoints;
        me.#pointSizeInput.value = me.#CircleSize.toString();
        me.#showPaintIndicatorInput.checked = this.#showPaintIndicator;
        me.#showAngleLabelsInput.checked = this.#showAngleLabels;
        me.#angleLabelLimitInput.value = this.#angleLabelLimit.toString();
        me.#showLengthLabelsInput.checked = this.#showLengthLabels;
        me.#lengthLabelLimitInput.value = this.#lengthLabelLimit.toString();
        me.#bendRadiusInput.value = round(this.#BendRadius / this.ScaleFactor, 3).toString();
        me.#grayBackgroundInput.value = this.#grayBackground;

        this.#svgContainer.style.backgroundColor = this.#grayBackground;
    }

    updateUI() {
        this.#svgContainer.style.backgroundColor = this.#grayBackground;
        this.updateDrawingObjects();
    }

    saveSettings() {
        let settingsObject = {
            ProfileOnly: this.#profileOnly,
            Snap: this.#Snap,
            SnapPrecision: this.#SnapPrecision,
            ShowPoint: this.#showPoints,
            PointSize: this.#CircleSize,
            ShowPaintIndicator: this.#showPaintIndicator,
            ShowAngleLabels: this.#showAngleLabels,
            AngleLabelLimit: this.#angleLabelLimit,
            ShowLengthLabels: this.#showLengthLabels,
            LengthLabelLimit: this.#lengthLabelLimit,
            BendRadius: this.#BendRadius,
            GrayBackground: this.#grayBackground,
        };
        let strJson = JSON.stringify(settingsObject);

        localStorage.setItem(this.#settingsKey, strJson);
    }


    getSettings() {
        if (localStorage.getItem(this.#settingsKey) === null) {
            if (isMobile()) {
                this.#CircleSize = 40;
            } else {
                this.#CircleSize = 20;
            }

            this.saveSettings();
        }

        let strSettings = localStorage.getItem(this.#settingsKey);
        if (strSettings === null) {
            return; // Must have been an error saving settings to local storage.
        }
        let settingsObject = JSON.parse(strSettings);

        this.#profileOnly = settingsObject.ProfileOnly;
        this.#Snap = settingsObject.Snap;
        this.#SnapPrecision = settingsObject.SnapPrecision;
        this.#showPoints = settingsObject.ShowPoint;
        this.#CircleSize = settingsObject.PointSize;
        this.#showPaintIndicator = settingsObject.ShowPaintIndicator;
        this.#showAngleLabels = settingsObject.ShowAngleLabels;
        this.#angleLabelLimit = settingsObject.AngleLabelLimit;
        this.#showLengthLabels = settingsObject.ShowLengthLabels;
        this.#lengthLabelLimit = settingsObject.LengthLabelLimit;
        this.#BendRadius = settingsObject.BendRadius;
        this.#grayBackground = settingsObject.GrayBackground;
    }

    getOrientation() {
        var orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";
        return orientation;
    }



}